import { create } from "zustand"

interface FilterTransitionStore {
  selected: string[]
  set: (filter: string) => void
}

export const useFilterTransitionStore = create<FilterTransitionStore>((set) => ({
  selected: [],
  set: (filter: string) => set((prev) => ({ selected: [...prev.selected, filter] })),
}))

type FilterStatus = "idle" | "hidden" | "visible"

interface FilterStore {
  status: FilterStatus
  set: (value: FilterStatus) => void
}

export const useFilterStore = create<FilterStore>((set) => ({
  status: "idle",
  set: (value: FilterStatus) => set(() => ({ status: value })),
}))
